import { Component } from '@angular/core';
import { Links } from './foc-links';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog, MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    template: require('./foc-viewrequests.component.html'),
    styles: [require('./foc-viewrequests.component.scss')]
})

export class FOCviewRequestsComponent {
    data: any = [];
    dialogRef;
    id: any;
    navLinks = [
        new Links('1', 'create', 'add_user_information', 'create/'),
           new Links('2','FOC','FOC item details','return/'),
           new Links('3','Confirm details','Confirm all details','confirm/')
    ];
    userData: any;
    orderId: any;
    sapFOCNo: any;
    reqStatus:any;
    isApprover: boolean = false;
    isAdmin: boolean = false;
    pageName = 'viewRequest';
    param=''
    hasAutoActionRun:boolean = false;
    private destroy$ = new Subject<void>();

    constructor(private router: Router, private commonService: CommonService, private route: ActivatedRoute, private sessionHandler: SessionHandler,
        private http: HttpService, private dialog: MdDialog) {
        this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
        
        this.param = '';
        // this.route.queryParams.subscribe(
            //     params => {
                //         console.log(params['action'])
                //         if(params['action']){
                    //             this.param =  params['action']      
                    //         }else{
                        //             this.param =  ""
                        //         }
                        //     //   this.param =  params['action']?params['action'].:'';
                        //       console.log(this.param)
                        
                        //     }
                        //   )
        this.param=this.route.snapshot.queryParamMap.get('action');
        console.log(this.param)

    }
    ngOnInit() {
        setTimeout(()=>{
        this.commonService.viewData.pipe(take(1)).subscribe((value) => {
            console.log('VIEW DATA RECEIVED 👉', value);

            this.data = value;
            this.setlinks(this.data);
            console.log(this.reqStatus)
            // console.log(this.userData)
        });
        })

    }
    ngOnDestroy(){
        this.param = "";
        console.log(this.param)

this.destroy$.next();
    this.destroy$.complete();

    }

    public setlinks(data) {
        this.isApprover = false;
        this.isAdmin = false;
        if (data && (data.sapReturnOrderId || data.i ||data.sapFOCNo)) {
            const orderNo = data.sapReturnOrderId || data.id;
            const sapFOCNo = data.sapFOCNo
            const reqStatus = data.status

this.orderId = orderNo;
this.sapFOCNo = sapFOCNo;
this.reqStatus = reqStatus;

this.navLinks = [
  new Links('1', 'create', 'add_user_information', 'create/' + orderNo),
  new Links('2','FOC','FOC item details','return/' + orderNo),
  new Links('3','Confirm Details','Confirm all details','confirm/' + orderNo)
];

            if (this.userData && this.userData.role && this.userData.role.length > 0) {
                // if (this.userData.role.includes('APPROVER')) {  /**Old logic */
                //     this.isApprover = true;
                // }
                
                // if (((this.userData.role.includes('COMMERCIAL_APPROVER') && data.returnOrderCategory=='COMMERCIAL') 
                // || (this.userData.role.includes('LOGISTIC_APPROVER') && data.returnOrderCategory=='LOGISTIC') 
                // || (this.userData.role.includes('END_CONSUMER_APPROVER') && data.returnOrderCategory=='CONSUMER'))) {
                //     if(this.userData.approverType && !this.userData.approverType.includes(data.orderSize)){
                //         this.navigateToDashbord();
                //     }else{
                //         this.isApprover = true;
                //     }
                // }
                let isAPPR = this.userData.role.includes('FOC_APPROVER'); 
                
                const level2Approver  = ((data && data.level2Approver) != null ? data.level2Approver : '').toLowerCase().trim();
                const level1Approver  = ((data && data.level1Approver) != null ? data.level1Approver : '').toLowerCase().trim();
                const additionalApprover  = ((data && data.additionalApprover) != null ? data.additionalApprover : '').toLowerCase().trim();
                const userEmail = ((this.userData && this.userData.email) != null ? this.userData.email : '').toLowerCase().trim();
                
                const emailMatched =
                userEmail !== '' &&
                (
                    (level1Approver !== '' && userEmail === level1Approver) ||
                    (level2Approver !== '' && userEmail === level2Approver) ||
                    (additionalApprover !== '' && userEmail === additionalApprover)
                );

                if (this.userData.role.includes('FOC_ADMINISTRATOR')) {
                    this.isAdmin = true;
                }
                else if(isAPPR){

                    this.isApprover = false;
                    if(isAPPR && emailMatched) this.isApprover = true;
                    if(!this.isApprover)
                        this.navigateToDashbord();
                } 
            }
            
        }
        console.log(this.param)
        if(!this.hasAutoActionRun && ( this.isApprover || this.isAdmin ) && (data.status == 'PENDING' || data.status == 'LEVEL1_APPROVED')){
            if(this.param=='0'){
                this.hasAutoActionRun= true;
                this.clearActionQueryParam();
                this.confirmAction('reject');
              }else if(this.param=='1'){
                this.hasAutoActionRun = true;
this.clearActionQueryParam();
                this.confirmAction('approve');
              }
        }
    }
    private clearActionQueryParam() {
  // Removes `action` from the URL without reloading navigation history
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { action: null },
    queryParamsHandling: 'merge',
    replaceUrl: true
  });
}


    public printLabel(id) {
        let data = {};
        data['orderId'] = id;

        this.http.postRequest(data, 'returnOrder/v1/printLabelPdf').subscribe(
            res => {
                this.savePrintResponse(id, res);
            },
            err => {
                //alert('Failed');
                if(err && err.status!=0){
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed';

                }
                this.http.onEnd();
            }
        );
    }
navigateToDashbord(){
    this.dialogRef = this.dialog.open(dialogComponent);
    this.dialogRef.componentInstance.msg = 'You do not have access to View/Approve/Reject this Return.';
    this.dialogRef.afterClosed().subscribe(result => {
        this.router.navigateByUrl('/app/foc_dashboard');
    });
}

    public savePrintResponse(id, res) {
        if (res.responseStatus == 'Success') {
            var link = document.createElement('a');
            link.href = res.fileUrl;
            link.download = 'file.pdf';
            // link.dispatchEvent(new MouseEvent('click'));
            window.open(res.fileUrl, "_blank");
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Unable to print label.';
        }
        this.http.onEnd();
    }

    // public updateStatus(status) {
    //     let txtStatus;
    //     if (status == 'approved') {
    //         txtStatus = 'APPROVE';
    //     } else if (status == 'rejected') {
    //         txtStatus = 'REJECT';
    //     }
    //     this.dialogRef = this.dialog.open(dialogComponent);
    //     this.dialogRef.componentInstance.msg = 'Are you sure you want to ' + txtStatus + ' this request?';
    //     this.dialogRef.componentInstance.isConfirm = true;
    //     this.dialogRef.afterClosed().subscribe(result => {
    //         if (result) {
    //             let data = {};
    //             data['email'] = this.userData.email;
    //             data["userId"] = this.userData.userId;
    //             data['orderId'] = this.data.sapReturnOrderId;
    //             if (status == 'approved') {
    //                 data['status'] = 'APPR';
    //             } else if (status == 'rejected') {
    //                 data['status'] = 'REJE';
    //             }
    //             let today = new Date();
    //             let dd = ('0' + today.getDate()).slice(-2);
    //             let mm = ('0' + (today.getMonth() + 1)).slice(-2);
    //             let yyyy = today.getFullYear();
    //             data['approvalDate'] = yyyy + '' + mm + '' + dd;

    //             this.http.postRequest(data, 'returnOrder/v1/updateReturnOrderStatus').subscribe(
    //                 res => {
    //                     this.saveResponse(res, status);
    //                 },
    //                 err => {
    //                     // alert('Submit Failed');
    //                     this.dialogRef = this.dialog.open(dialogComponent);
    //                     this.dialogRef.componentInstance.msg = 'Submit Failed';
    //                     this.http.onEnd();
    //                 }
    //             );
    //         }
    //         this.dialogRef = null;
    //     });
    // }

    public saveResponse(res, status) {
        this.http.onEnd();
        if (res.status == 'Success') {
            if (status == 'approved') {
                status = 'APPROVED';
            } else if (status == 'rejected') {
                status = 'REJECTED';
            }
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Request successfully ' + status;
            this.dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.commonService.setData(null);
                    this.router.navigateByUrl('/app/foc_dashboard');
                }
                this.dialogRef = null;
            });
        }
        if (res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
    }
  
    
//       fetchPage(pageNum: number, size: number, status: string = '', extraFilters: any = null) {
//     // mark loading
//     this.isLoadingPage = true;
  
//     let params = 'page=' + pageNum + '&size=' + size;
//     if (status) params += '&status=' + encodeURIComponent(status);
  
//     const url = 'focApi/v1/getFOCRequestList?' + params;
  
//     // ADVANCED SEARCH → send filters as POST body
//     if (extraFilters) {
//       this.http.postRequest(extraFilters, url).subscribe(
//         (res: any) => {
//           this.http.onEnd();
//           this.mapResponseToRows(res);
//           this.isLoadingPage = false;

//         },
//         err => {
//           this.isLoadingPage = false;

//           console.error('Failed to fetch FOC requests', err);
//           if (err && err.status != 0) {
//             this.dialogRef = this.dialog.open(dialogComponent);
//             this.dialogRef.componentInstance.msg = 'Failed to load FOC requests.';
//           }
//           this.http.onEnd();
//         }
//       );
//       return;
//     }
  
//     // DEFAULT DASHBOARD → same API but with empty JSON body
//     const emptyBody = {};
  
//     this.http.postRequest(emptyBody, url).subscribe(
//       (res: any) => {
//         this.http.onEnd();
//         this.mapResponseToRows(res);
//         this.isLoadingPage = false;

//       },
//       err => {
//         this.isLoadingPage = false;

//         console.error('Failed to fetch FOC requests', err);
//         if (err && err.status != 0) {
//           this.dialogRef = this.dialog.open(dialogComponent);
//           this.dialogRef.componentInstance.msg = 'Failed to load FOC requests.';
//         }
//         this.http.onEnd();
//       }
//     );
//   }

    confirmAction(action: 'approve'|'reject') {
    const verb = action === 'approve' ? 'APPROVE' : 'REJECT';
    this.dialogRef = this.dialog.open(dialogComponent);
    this.dialogRef.componentInstance.msg = 'Are you sure you want to ' + verb + ' this request?';
    this.dialogRef.componentInstance.isConfirm = true;
    this.dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
  
      // determine current status (prefer original status if available)
    //   const currentStatusRaw = (row.original && row.original.status) ? row.original.status : row.status;
    const currentStatus = ((this.data && this.data.status) != null ? this.data.status : '').toUpperCase().trim()
    //   const currentStatus = this.data.status ? String(currentStatusRaw).trim().toUpperCase() : '';
  
      // determine new status according to your rule
      let newStatus: string;
      if (action === 'reject') {
        newStatus = 'REJECTED';
      } else {
        // approve: move to next level — if already LEVEL1_APPROVED -> LEVEL2_APPROVED
        // otherwise set LEVEL1_APPROVED
        newStatus = (currentStatus === 'LEVEL1_APPROVED') ? 'LEVEL2_APPROVED' : 'LEVEL1_APPROVED';
      }
  
      // build payload to match backend expectation
      const makeYYYYMMDD = (d: Date) => {
        const yyyy = d.getFullYear();
        const mm = ('0' + (d.getMonth() + 1)).slice(-2);
        const dd = ('0' + d.getDate()).slice(-2);
        return '' + yyyy + mm + dd;
      };
  
      const payload: any = {
        focId: this.orderId,
        status: newStatus,
        email: this.userData && this.userData.email ? this.userData.email : null,
        userId: this.userData && this.userData.userId ? this.userData.userId : null,
        approvalDate: makeYYYYMMDD(new Date())
      };
  
      this.http.postRequest(payload, 'focApi/v1/updateFOCStatus').subscribe(
        (res: any) => {
          this.http.onEnd();
  
          const okCondition = res && (res.status === 'Success' || res.responseCode === 200 || res.success);
          if (okCondition) {
            // update UI model (both displayed status and original payload)
            // row.status = newStatus;
            // this.fetchPage(this.page.pageNumber, this.page.size);
            // if (row.original) row.original.status = newStatus;
  
            // const ok = this.dialog.open(dialogComponent);
            // ok.componentInstance.msg = 'Request ' + (action === 'approve' ? 'approved' : 'rejected') + ' successfully.';
            this.saveResponse(res, (action === 'approve' ? 'approved' : 'rejected'));
          } else {
            const errDlg = this.dialog.open(dialogComponent);
            errDlg.componentInstance.msg = (res && res.errorMessage) ? res.errorMessage : 'Failed to process request. Please contact administrator.';
          }
        },
        err => {
          console.error('Approve/Reject error', err);
          if (err && err.status != 0) {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = err;
          }
          this.http.onEnd();
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/FOCviewRequest/foc-viewrequests.component.ts